const EDD = {
  AU: {
    earliest: 4,
    latest: 7,
  },
  HK: {
    earliest: 4,
    latest: 6,
  },
  IT: {
    earliest: 4,
    latest: 6,
  },
  JP: {
    earliest: 5,
    latest: 7,
  },
  SK: {
    earliest: 7,
    latest: 9,
  },
  RoW: {
    earliest: 4,
    latest: 7,
  },
  CA: {
    earliest: 5,
    latest: 7,
    states: {
      AB: {
        earliest: 3,
        latest: 5,
      },
      BC: {
        earliest: 4,
        latest: 6,
      },
      MB: {
        earliest: 4,
        latest: 6,
      },
      NB: {
        earliest: 4,
        latest: 6,
      },
      NL: {
        earliest: 4,
        latest: 6,
      },
      NS: {
        earliest: 7,
        latest: 9,
      },
      ON: {
        earliest: 4,
        latest: 6,
      },
      PE: {
        earliest: 4,
        latest: 6,
      },
      QC: {
        earliest: 4,
        latest: 6,
      },
      SK: {
        earliest: 4,
        latest: 6,
      },
    },
  },
  US: {
    earliest: 4,
    latest: 6,
    states: {
      AA: {
        earliest: 12,
        latest: 14,
      },
      AE: {
        earliest: 13,
        latest: 15,
      },
      AK: {
        earliest: 7,
        latest: 9,
      },
      AL: {
        earliest: 5,
        latest: 7,
      },
      AP: {
        earliest: 11,
        latest: 13,
      },
      AR: {
        earliest: 5,
        latest: 7,
      },
      AZ: {
        earliest: 6,
        latest: 8,
      },
      CA: {
        earliest: 5,
        latest: 7,
      },
      CO: {
        earliest: 5,
        latest: 7,
      },
      CT: {
        earliest: 3,
        latest: 5,
      },
      DC: {
        earliest: 3,
        latest: 5,
      },
      DE: {
        earliest: 3,
        latest: 5,
      },
      FL: {
        earliest: 5,
        latest: 7,
      },
      GA: {
        earliest: 5,
        latest: 7,
      },
      GU: {
        earliest: 19,
        latest: 21,
      },
      HI: {
        earliest: 8,
        latest: 10,
      },
      IA: {
        earliest: 4,
        latest: 6,
      },
      ID: {
        earliest: 6,
        latest: 8,
      },
      IL: {
        earliest: 5,
        latest: 7,
      },
      IN: {
        earliest: 5,
        latest: 7,
      },
      KS: {
        earliest: 5,
        latest: 7,
      },
      KY: {
        earliest: 5,
        latest: 7,
      },
      LA: {
        earliest: 6,
        latest: 8,
      },
      MA: {
        earliest: 3,
        latest: 5,
      },
      MD: {
        earliest: 3,
        latest: 5,
      },
      ME: {
        earliest: 3,
        latest: 5,
      },
      MI: {
        earliest: 5,
        latest: 7,
      },
      MN: {
        earliest: 5,
        latest: 7,
      },
      MO: {
        earliest: 5,
        latest: 7,
      },
      MS: {
        earliest: 6,
        latest: 8,
      },
      MT: {
        earliest: 6,
        latest: 8,
      },
      NC: {
        earliest: 4,
        latest: 6,
      },
      ND: {
        earliest: 5,
        latest: 7,
      },
      NE: {
        earliest: 5,
        latest: 7,
      },
      NH: {
        earliest: 3,
        latest: 5,
      },
      NJ: {
        earliest: 3,
        latest: 5,
      },
      NM: {
        earliest: 6,
        latest: 8,
      },
      NV: {
        earliest: 6,
        latest: 8,
      },
      NY: {
        earliest: 3,
        latest: 5,
      },
      OH: {
        earliest: 4,
        latest: 6,
      },
      OK: {
        earliest: 5,
        latest: 7,
      },
      OR: {
        earliest: 6,
        latest: 8,
      },
      PA: {
        earliest: 3,
        latest: 5,
      },
      PR: {
        earliest: 7,
        latest: 9,
      },
      RI: {
        earliest: 3,
        latest: 5,
      },
      SC: {
        earliest: 4,
        latest: 6,
      },
      SD: {
        earliest: 5,
        latest: 7,
      },
      TN: {
        earliest: 4,
        latest: 6,
      },
      TX: {
        earliest: 5,
        latest: 7,
      },
      UT: {
        earliest: 5,
        latest: 7,
      },
      VA: {
        earliest: 3,
        latest: 5,
      },
      VI: {
        earliest: 7,
        latest: 9,
      },
      VT: {
        earliest: 4,
        latest: 6,
      },
      WA: {
        earliest: 6,
        latest: 8,
      },
      WI: {
        earliest: 4,
        latest: 6,
      },
      WV: {
        earliest: 4,
        latest: 6,
      },
      WY: {
        earliest: 7,
        latest: 9,
      },
    },
  },
};

export default EDD;
